module.exports = __webpack_public_path__ + "static/img/8.6234889.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/zh/8.png
// module id = boLc
// module chunks = 0